var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00347 3.59945C8.06948 3.47602 8.12933 3.36756 8.18742 3.25722C8.46051 2.70704 8.78485 2.18732 9.15559 1.70592C9.71302 0.973864 10.4612 0.432652 11.3067 0.149977C12.0543 -0.0803763 12.8523 -0.0445817 13.5791 0.251878C14.3058 0.548338 14.9212 1.0892 15.3316 1.79196C15.6928 2.39502 15.9142 3.08048 15.9776 3.79207C16.0675 4.91056 15.8857 6.03484 15.4495 7.05732C14.9976 8.15928 14.3888 9.18078 13.6444 10.086C12.4452 11.5498 11.0721 12.842 9.55957 13.93C9.07813 14.2872 8.57909 14.6192 8.08885 14.9633C8.06929 14.9839 8.04358 14.9967 8.01612 14.9995C7.98866 15.0022 7.96116 14.9947 7.93834 14.9782C6.4487 14.0119 5.05065 12.8946 3.76379 11.6419C2.77877 10.6908 1.92009 9.60174 1.21136 8.40472C0.711654 7.56197 0.348403 6.63623 0.136694 5.66593C0.0202443 5.12193 -0.0221392 4.563 0.0108349 4.0062C0.0524633 2.9521 0.450236 1.94924 1.13126 1.18138C1.66283 0.573057 2.37205 0.173074 3.14417 0.0461915C3.66965 -0.0389855 4.20621 -0.00333651 4.71761 0.150718C5.22901 0.304773 5.70332 0.573661 6.10851 0.939193C6.71575 1.46478 7.2207 2.11113 7.59508 2.84205L8.00347 3.59945Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.53422c1c4e8c59a2a0f84a724764212b.svg";
export { ForwardRef as ReactComponent };